/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from "zod/v4";

export const reportOverviewPipelineDtoSchema = z.object({
  stage: z.optional(z.string()),
  sector: z.optional(z.string()),
  deckId: z.optional(z.string()),
  lastUpdate: z.optional(z.string()),
});
